module.exports = __webpack_public_path__ + "img/dangdang-propa.e844d4e5.png";